export const FORGOT_PASSWORD_FAILED_MESSAGE = "error:password.forgot-password-failed"
export const VERIFY_RESET_PASSWORD_CODE_FAILED_MESSAGE = "error:password.verify-reset-password-code-failed"
export const RESET_PASSWORD_FAILED_MESSAGE = "error:password.reset-password-failed"
